import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';
import { Anchor, Award, TrendingUp } from 'lucide-react';

const About = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const isRTL = language === 'ar';

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#003d5c] mb-6">
            {t.about.title}
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            {t.about.description}
          </p>
          <p className="text-lg text-[#003d5c] font-semibold mt-6">
            {t.about.subtitle}
          </p>
        </div>

        {/* Stats/Features Grid */}
        <div className="grid md:grid-cols-3 gap-8 mt-12">
          <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-blue-50 to-white border border-blue-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#003d5c] rounded-full mb-4">
              <Anchor className="h-8 w-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-[#003d5c] mb-2">Global Network</h3>
            <p className="text-gray-600">
              {language === 'en' ? 'Operating at major ports worldwide' : 'نعمل في الموانئ الرئيسية عالمياً'}
            </p>
          </div>

          <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-blue-50 to-white border border-blue-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#003d5c] rounded-full mb-4">
              <Award className="h-8 w-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-[#003d5c] mb-2">
              {language === 'en' ? 'Trusted Partner' : 'شريك موثوق'}
            </h3>
            <p className="text-gray-600">
              {language === 'en' ? 'Reliable freight forwarding services' : 'خدمات شحن موثوقة'}
            </p>
          </div>

          <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-blue-50 to-white border border-blue-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#003d5c] rounded-full mb-4">
              <TrendingUp className="h-8 w-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-[#003d5c] mb-2">
              {language === 'en' ? 'Growth Focused' : 'تركيز على النمو'}
            </h3>
            <p className="text-gray-600">
              {language === 'en' ? 'Helping businesses expand globally' : 'مساعدة الشركات على التوسع عالمياً'}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;